// NPM Imports
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import ReactHtmlParser from "react-html-parser";
import Modal from "react-responsive-modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Input, Label, Tooltip, Toastr } from "../../../revvComponents";
import FolderManagerPopup from "../FieldsData/CreateDocumentWithData/FolderManagerPopup";

// Services imports

// Action imports
import { fetchAllDocumentTemplates } from "../../../actions/DocumentTemplateActions/templateActions";
import {
  getAssetFolderContentAction,
  getAssetFolderTreeAction,
} from "../../../actions/AssetActions/assetActions";
// Internal Imports
import { GlobalUtils } from "../../../utils";
import { IMAGE_URLS, FIELDS } from "../../../constants";
import {
  createTriggerAction,
  updateTriggerAction,
} from "../../../actions/FieldsSetting/fieldsSettingActions";
import LZLoader from "../../../commonComponents/LZLoader";

const {
  truncateString,
  readDataFromLocalStorage,
  handleApiErrMsg,
  // getAssetFolderUrl,
} = GlobalUtils;

const { DATA_SOURCES } = FIELDS;
const { FOLDER_ICO, SHIELD } = IMAGE_URLS;
class CreateTriggerPopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showTemplateSelectionPopup: false,
      errorMsg: "",
      showMultiDocCreationLoader: false,
      showFolderManagerPopup: false,
      selectedBreadCrumPath: "All documents",
      breadcrumbData: [],
      selectedDocCreateType: "documemntCreate",
      showBoxAuthLoader: false,
    };
  }

  componentDidMount() {
    this.props
      .getAssetFolderTreeAction()
      .then(() => {
        console.debug("Success");
      })
      .catch(error => {
        console.debug(
          `Asset => getAssetFolderTree => _onInitAssets => Error : ${error}`,
        );
      });
    const payload = `page_num=1`;
    this.props.fetchAllDocumentTemplates();
    this.props
      .getAssetFolderContentAction(payload, null, "all")
      .then(() => {
        console.debug("Success");
      })
      .catch(error => {
        console.debug(
          `Fields => get folder structure for doc creation => _onInit Create Document Popup => Error : ${error}`,
        );
      });
    const { triggerDetails, currentSelectedObject } = this.props;
    const currTriggerInfo = triggerDetails[currentSelectedObject];
    if (currTriggerInfo && currTriggerInfo.trigger_id) {
      if (currTriggerInfo.event_action === "create_doc") {
        this.setState({ selectedDocCreateType: "documemntCreate" });
      } else if (currTriggerInfo.event_action === "esignatures") {
        this.setState({ selectedDocCreateType: "esign" });
      }
      this.setState({
        selectedFolderID: currTriggerInfo.folder_id,
      });
    }
  }

  _closePopup = () => {
    this.props.closePopup();
  };

  _createTrigger = () => {
    const { templateId } = this.props;
    const { selectedDocCreateType } = this.state;
    const user = readDataFromLocalStorage("revvsalesUser");
    let orgId = null;
    if (user && user.org_id) {
      if (!Number.isNaN(parseInt(user.org_id, 10))) {
        orgId = parseInt(user.org_id, 10);
      }
    }
    let action = null;
    if (selectedDocCreateType === "documemntCreate") {
      action = "create_doc";
    } else if (selectedDocCreateType === "esign") {
      action = "esignatures";
    }
    const dataSource = DATA_SOURCES.find(
      ds => ds.name === this.props.dataSourceSelected,
    );
    const createTriggerPayload = {
      org_id: orgId,
      template_id: templateId,
      event_action: action,
      folder_id: this.state.selectedFolderID || 0,
      data_source: dataSource.urlRef,
      object_name: this.props.currentSelectedObject,
      is_active: true,
    };
    if (orgId === null) {
      delete createTriggerPayload.org_id;
    }
    this.props
      .createTriggerAction(createTriggerPayload)
      .then(() => {
        this.setState({
          showMultiDocCreationLoader: false,
        });
        Toastr.showToastr({
          type: "success",
          message: "Trigger created sucessfully!",
          timeout: 3000,
        });
        this.props.closePopup();
      })
      .catch(() => {
        this.setState({
          showMultiDocCreationLoader: false,
        });
        Toastr.showToastr({
          type: "failure",
          message: "Something went wrong!",
          timeout: 3000,
        });
        this.props.closePopup();
      });
  };

  _updateTrigger = () => {
    const { triggerDetails, currentSelectedObject } = this.props;
    const { selectedFolderID, selectedDocCreateType } = this.state;
    const currTriggerInfo = triggerDetails[currentSelectedObject];
    let action = null;
    if (selectedDocCreateType === "documemntCreate") {
      action = "create_doc";
    } else if (selectedDocCreateType === "esign") {
      action = "esignatures";
    }
    if (
      currTriggerInfo.folder_id !== selectedFolderID ||
      currTriggerInfo.event_action !== action
    ) {
      const updateTriggerPayload = {
        event_action: action,
        folder_id: this.state.selectedFolderID || 0,
        is_active: currTriggerInfo.is_active,
      };
      this.props
        .updateTriggerAction(updateTriggerPayload, currTriggerInfo.trigger_id)
        .then(() => {
          this.setState({
            showMultiDocCreationLoader: false,
          });
          Toastr.showToastr({
            type: "success",
            message: "Trigger updated successfully!",
            timeout: 3000,
          });
          this.props.closePopup();
        })
        .catch(() => {
          this.setState({
            showMultiDocCreationLoader: false,
          });
          Toastr.showToastr({
            type: "failure",
            message: "Something went wrong!",
            timeout: 3000,
          });
          this.props.closePopup();
        });
    }
  };

  _getBreadCrumbDetails = (breadCrumb, index, len) => {
    let breadCru = "";
    if (breadCrumb.name !== "All" && index !== len - 1) {
      breadCru = truncateString(breadCrumb.name, 3, true, 2);
    } else if (index === len - 1 && breadCrumb.name.length > 12) {
      breadCru = truncateString(breadCrumb.name, 5, true, 2);
    } else breadCru = breadCrumb.name;
    return breadCru;
  };

  _getFolderPath = (breadcrumbData, folderID) => {
    const breadcrumbPath = [];
    breadcrumbData.forEach((bc, index) => {
      if (bc.name) {
        breadcrumbPath.push(
          `${this._getBreadCrumbDetails(bc, index, breadcrumbData.length)}/`,
        );
      }
    });
    // const urlPathData = breadcrumbData[breadcrumbData.length - 1];
    // const urlPathname = getAssetFolderUrl(urlPathData.name, urlPathData.id);
    this.setState({
      selectedBreadCrumPath: breadcrumbPath.join(""),
      showFolderManagerPopup: false,
      breadcrumbData,
      // urlPathname,
      selectedFolderID: folderID,
    });
  };

  _onSelectChange = value => {
    this.setState({ selectedDocCreateType: value });
  };

  closeFolderPopup = () => this.setState({ showFolderManagerPopup: false });

  _getTemplateSelectionView = () => {};

  _toggleLoader = flag => {
    this.setState({ showBoxAuthLoader: flag });
  };

  _connectToBoxAccount = () => {
    this._toggleLoader(true);
    const { clientId, clientSecret, redirectUrl, instanceUrl } =
      this.props.boxConfig;
    const config = {
      crm: "BOX",
      instance_url: instanceUrl.trim(),
      redirect_url: redirectUrl.trim(),
      client_id: clientId.trim(),
      client_secret: clientSecret.trim(),
      oauth_type: "user",
    };
    this._toggleLoader(true);
    this.props
      .authenticateCRM(config, window.location.pathname)
      .then(() => {
        this._toggleLoader(false);
      })
      .catch(error => {
        this._toggleLoader(false);
        Toastr.showToastr({
          type: "failure",
          message: handleApiErrMsg(error),
          timeout: 3000,
        });
      });
  };

  _decideSendForEsignCondition = () => {
    const {
      boxConfig: { isCRMAuthenticated },
      isUserLoggedIntoBoxAcnt,
    } = this.props;

    if (!isCRMAuthenticated) {
      return (
        <div className="select-type-create-doc">
          <Label className="select-type-label-name">
            <Input
              type="radio"
              name="choose_creation_type"
              value
              disabled
              data-test="send-for-esign-data-studio"
            />
            Send for esign
          </Label>
          <div className="datastudio-box-connect-esign">
            <FontAwesomeIcon icon={["far", "plug"]} /> Integrate with Box &nbsp;
            <Tooltip
              placement="bottom"
              overlay="Contact your admin to integrate with Box to proceed with eSignature"
              align={{
                offset: [6, 0],
              }}>
              <span className="btn-icon">
                <FontAwesomeIcon icon={["far", "info-circle"]} />
              </span>
            </Tooltip>
          </div>
        </div>
      );
    }

    if (!isUserLoggedIntoBoxAcnt) {
      return (
        <div className="select-type-create-doc">
          <Label className="select-type-label-name">
            <Input
              type="radio"
              name="choose_creation_type"
              value
              disabled
              data-test="send-for-esign-data-studio"
            />
            Send for esign
          </Label>
          {this.state.showBoxAuthLoader ? (
            <div>
              <FontAwesomeIcon icon={["fas", "spinner"]} className="fa-spin" />
            </div>
          ) : (
            <div
              className="datastudio-box-connect-esign"
              role="button"
              tabIndex="0"
              onKeyPress={() => {}}
              onClick={this._connectToBoxAccount}>
              <FontAwesomeIcon icon={["far", "link"]} /> Connect to box &nbsp;
              <Tooltip
                placement="bottom"
                overlay="Connect to box to send for eSignature"
                align={{
                  offset: [6, 0],
                }}>
                <span className="btn-icon">
                  <FontAwesomeIcon icon={["far", "info-circle"]} />
                </span>
              </Tooltip>
            </div>
          )}
        </div>
      );
    }
    return <Fragment />;
  };

  _getCreateDocPopupView = () => {
    const { selectedDocCreateType } = this.state;
    const { triggerDetails, currentSelectedObject } = this.props;
    const currTriggerInfo = triggerDetails[currentSelectedObject];

    // Default size for file type
    const iconWidth = "20px";
    const iconHeight = "26px";
    let buttonValue = "Create Trigger";
    if (currTriggerInfo && currTriggerInfo.trigger_id) {
      buttonValue = "Update Trigger";
    }
    return (
      <div>
        <div
          className="modal-heading withprogress"
          data-test="multidocpopup-modal-heading">
          <div>Create an API triggered automation</div>
        </div>
        <div className="multidocpopup-info addproduct-info">
          <div>
            <img
              src={SHIELD}
              alt="Revv"
              className="info-signer-icon"
              width="35"
            />
          </div>
          <div className="info-subtitle">
            Give some subext here regarding how the automation will work
          </div>
        </div>
        <div className="multidocpopup-step">
          <div className="step-header">STEP 1</div>
          <div className="step-text">Select what would you like to do</div>
          <div className="select-doc-creation-option">
            <div className="select-type-create-doc">
              <Label className="select-type-label-name">
                <Input
                  type="radio"
                  name="choose_creation_type"
                  value
                  checked={selectedDocCreateType === "documemntCreate"}
                  onChange={() => this._onSelectChange("documemntCreate")}
                  data-test="create-documents-only-data-studio"
                />
                Create documents only
              </Label>
            </div>

            {!this.props.isBoxEsignFlow ||
            (this.props.isBoxEsignFlow &&
              this.props.boxConfig.isCRMAuthenticated &&
              this.props.isUserLoggedIntoBoxAcnt) ? (
              <div className="select-type-create-doc">
                <Label className="select-type-label-name">
                  <Input
                    type="radio"
                    name="choose_creation_type"
                    value
                    checked={selectedDocCreateType === "esign"}
                    onChange={() => this._onSelectChange("esign")}
                    data-test="send-for-esign-data-studio"
                  />
                  Send for esign
                </Label>
              </div>
            ) : (
              this._decideSendForEsignCondition()
            )}
            <div className="select-type-create-doc">
              <Label className="select-type-label-name">
                <Input
                  type="radio"
                  name="choose_creation_type"
                  value
                  checked={selectedDocCreateType === "acceptance"}
                  onChange={() => this._onSelectChange("acceptance")}
                  data-test="Send-for-acceptance-data-studio"
                  disabled
                />
                Send for acceptance
              </Label>
              <div className="data-studio-coming-soon">coming soon</div>
            </div>
          </div>
        </div>
        {this.props.currentSelectedObject !== "Opportunity" && (
          <div className="multidocpopup-step">
            <div className="step-header">STEP 2</div>
            <div className="step-text">
              Select a folder to store these documents. You can access from
              there later
            </div>
            <div className="folder-path">
              Documents will be created in{" "}
              <img
                src={FOLDER_ICO}
                className="folder-icon"
                alt="icons"
                width={`${iconWidth}`}
                height={`${iconHeight}`}
              />{" "}
              {this.state.selectedBreadCrumPath.substring(
                0,
                this.state.selectedBreadCrumPath.length - 1,
              )}{" "}
              <div
                role="button"
                tabIndex={0}
                className="change-folder"
                onClick={() => {
                  this.setState({ showFolderManagerPopup: true });
                }}
                onKeyPress={() => {}}>
                Change folder
              </div>
            </div>
          </div>
        )}

        {this.state.errorMsg && (
          <div className="error-msg">
            {ReactHtmlParser(this.state.errorMsg)}
          </div>
        )}
        <section className="createquotepopup-footer popup-footer clearfix create-multi-doc-footer">
          {/* {this.state.disableBtn && (
            <Tooltip
              placement="top"
              align={{
                offset: [0, 4],
              }}
              overlay={"Select rows for which you want to create documents"}>
              <div className="multidocpopup-actions">
                <Button
                  className="revv-btn-success"
                  onClick={() => this._createBulkDocuments()}
                  data-test="templatedetails-preview-button"
                  disabled={this.state.disableBtn}>
                  {buttonValue}
                </Button>
              </div>
            </Tooltip>
          )} */}
          {/* {!this.state.disableBtn && ( */}
          <div className="createtrigger-popup-actions">
            <Button
              className="btn btn-transparent modal-footer-btn cancle-btn"
              data-test="data-studio-fetch-popup-cancle-btn"
              onClick={this.props.closePopup}>
              Cancel
            </Button>
            <Button
              className="revv-btn-success"
              disabled={!selectedDocCreateType}
              onClick={() =>
                currTriggerInfo && currTriggerInfo.trigger_id
                  ? this._updateTrigger()
                  : this._createTrigger()
              }
              data-test="templatedetails-preview-button">
              {buttonValue}
            </Button>
          </div>
          {/* )} */}
        </section>
      </div>
    );
  };

  _getCreateDocumentPopupView = () => {
    if (this.state.showTemplateSelectionPopup) {
      return this._getTemplateSelectionView();
    }
    return this._getCreateDocPopupView();
  };

  render() {
    return (
      <Fragment>
        <Modal
          open
          onClose={this._closePopup}
          center
          closeOnOverlayClick={false}
          className={`${
            this.state.showFolderManagerPopup ? "hide-modal" : ""
          }`}>
          <div className="multidocpopup-container">
            {this.state.showMultiDocCreationLoader && (
              <LZLoader
                theme="light"
                className="loader-bg-color"
                label="Please wait till your field data is getting validated."
              />
            )}
            {this._getCreateDocumentPopupView()}
            {/* ----------- Modal Heading Section ----------- */}
          </div>
        </Modal>
        {this.state.showFolderManagerPopup && (
          <FolderManagerPopup
            closePopup={this.closeFolderPopup}
            getFolderPath={this._getFolderPath}
            breadcrumbData={this.state.breadcrumbData}
            assetBreadcrumbData={this.props.assetBreadcrumbData}
          />
        )}
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  const { assetBreadcrumbData } = state.AssetStore;
  const {
    documentTemplates,
    template: { id: templateId },
  } = state.TemplateStore;
  const { dataSourceSelected, currentSelectedObject } =
    state.FieldsSettingStore;

  return {
    templateId,
    documentTemplates,
    assetBreadcrumbData,
    dataSourceSelected,
    currentSelectedObject,
  };
};

const mapDispatchToProps = {
  fetchAllDocumentTemplates,
  getAssetFolderContentAction,
  getAssetFolderTreeAction,
  createTriggerAction,
  updateTriggerAction,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(CreateTriggerPopup));
